import { get, getPublic, post, put, putPublic } from "../../data/api";
import { getToken, redirectToLogin } from "../../data/auth.service";
import { IsNullOrEmpty } from "../../services/CustomService";
import { normalizePhone } from "../../services/phone";

function normalizeMoneyParam(value) {
    if (value === null || value === undefined) {
        return value;
    }

    return String(value).trim().replace(',', '.');
}


// from / to : bornes facultatives au format AAAA-MM-JJ (date de fin de location, incluses).
export async function getRentalsHistory(toolId, start = 0, nb = 100, from = null, to = null) {
    const period = (from ? '&from=' + from : '') + (to ? '&to=' + to : '');
    return await get('rental/history/' + toolId + '?start=' + start + '&nb=' + nb + period)
}
export async function getUpcomingRentalsForTool(toolId) {
    return await get('rental/upcoming/' + toolId)
}
export async function getCompletedRentals(start, nb) {
    return await get('rental/history/completed/' + start + "/" + nb)
}
export async function getRentals() {
    return await get('rental')
}
export async function getRental(id) {
    return await get('rental/' + id)
}

function toNullableInt(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed) : null;
}

function parseRentalContacts(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    try {
        return JSON.parse(value);
    } catch {
        return [];
    }
}
export async function getFullContractPreviewUrl(id) {
    const response = await fetch('/api/rental/' + id + '/contract/full/preview',
        {
            headers: { Authorization: 'Bearer ' + getToken() }
        });

    if (response.status === 401) {
        redirectToLogin();
        return null;
    } else if (response.status === 403) {
        throw new Response("", { status: 403 });
    } else if (!response.ok) {
        throw new Error("Impossible de charger l'aperçu du contrat.");
    }

    const blob = await response.blob();
    return window.URL.createObjectURL(blob);
}
export async function downloadFullContract(id) {
    const response = await fetch('/api/rental/' + id + '/contract/full',
        {
            headers: { Authorization: 'Bearer ' + getToken() }
        });

    if (response.status === 401) {
        redirectToLogin();
        return;
    } else if (response.status === 403) {
        throw new Response("", { status: 403 });
    } else if (!response.ok) {
        throw new Error("Impossible de télécharger le contrat.");
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get('content-disposition') || "";
    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
    const filename = filenameMatch ? decodeURIComponent(filenameMatch[1].replace(/"/g, "")) : 'contrat_location_' + id + '.pdf';
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
export async function printDeliveryReceipt(id) {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
        printWindow.document.write('<html><head><title>Bon de livraison</title></head><body>G&eacute;n&eacute;ration du bon de livraison...</body></html>');
    }

    const response = await fetch('/api/rental/' + id + '/delivery-receipt',
        {
            headers: { Authorization: 'Bearer ' + getToken() }
        });

    if (response.status === 401) {
        if (printWindow) printWindow.close();
        redirectToLogin();
        return;
    } else if (response.status === 403) {
        if (printWindow) printWindow.close();
        throw new Response("", { status: 403 });
    } else if (!response.ok) {
        if (printWindow) printWindow.close();
        throw new Error("Impossible de generer le bon de livraison.");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    if (!printWindow) {
        const link = document.createElement('a');
        link.href = url;
        link.download = 'bon_livraison_' + id + '.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return;
    }

    printWindow.document.open();
    printWindow.document.write(
        '<html><head><title>Bon de livraison</title><style>html,body,iframe{width:100%;height:100%;margin:0;border:0;}</style></head><body><iframe id="deliveryReceipt" src="' + url + '"></iframe></body></html>'
    );
    printWindow.document.close();

    const iframe = printWindow.document.getElementById('deliveryReceipt');
    iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => window.URL.revokeObjectURL(url), 30000);
    };
}
export async function authorizePayment(id, fees) {
    let body = {
        Fees: fees
    };

    return await post(body,'rental/authorize-stripe-payment/' + id)
}
export async function getPrice(st, en, hour, toolPublicId) {


    return await get('rental/price/' + toolPublicId + "/" + st.toUTCString() + "/" + en.toUTCString() + "/" + hour)
}
export async function permanentLinkNeeded(start, end) {

    return await get('rental/permanent-link-needed/' + start + "/" + end)
}
export async function getActiveRentalPayment(id) {
    return await getPublic('public/rental/' + id + "/payment")
}
export async function getActiveRentalAdvancePayment(id) {
    return await getPublic('public/rental/' + id + "/advance-payment")
}
export async function getPublicRental(id) {
    return await getPublic('public/rental/' + id)
}
export async function savePublicRentalRefundBankAccount(id, values) {
    return await putPublic(values, 'public/rental/' + id + '/refund-bank-account')
}
export async function RentalsStats() {

    return await get('statistic/rentals')
}
export async function hub() {

    return await getPublic('public/hub')
}
export async function ServicesStats(startDate, endDate) {

    return await get('statistic/services/' + startDate + "/" + endDate)
}
export async function TopStats(startDate, endDate) {

    return await get('statistic/top/' + startDate + "/" + endDate)
}
export async function StatsDashboard(startDate, endDate) {

    return await get('statistic/dashboard/' + startDate + "/" + endDate)
}
export async function StatsDeliveries(startDate, endDate) {

    return await get('statistic/deliveries/' + startDate + "/" + endDate)
}
export async function CurrentMonthCharges() {

    return await get('statistic/current-month-charges')
}
export async function GlobalCA() {

    return await get('statistic/ca/')
}
export async function OngoingCA() {

    return await get('statistic/ongoing-ca/')
}
export async function next(id, clienResponse) {
    let obj = {
        ClientResponse: clienResponse
    };

    return await put(obj, 'rental/next/' + id)
}
export async function deleteRentalStep(id, step) {
    return await put(null, 'rental/step/' + id + '/' + encodeURIComponent(step))
}
export async function sendDepositLink(id) {
    return await put(null, 'rental/send-link-deposit/' + id)
}
export async function sendAdvancePaymentReminder(id) {
    return await put(null, 'rental/send-advance-payment-reminder/' + id)
}

export async function updateRemainingToBePaid(id, amount) {
   
    return await put(null, 'rental/remaining-to-be-paid/' + id + '/' + amount)
}
export async function addAdvancedPayment(id, amount, sendEmail = false) {

    return await put(null, 'rental/add-advanced-payment/' + id + '/' + encodeURIComponent(amount) + '?sendEmail=' + (sendEmail ? 'true' : 'false'))
}
export async function regenDepositLink(id) {
    return await put(null, 'rental/regenerate-deposit-link/' + id )
}

export async function updateRental(id, status, cancellationEmail = null) {
    let obj = {
        RentalId: id,
        Status: status,
        SendCancellationEmail: Boolean(cancellationEmail),
        CancellationReason: cancellationEmail?.reason ?? null
    };

    return await put(obj, 'rental/status')
}
export async function getLessorCancellationEmail(id) {
    return await get('rental/cancellation-email/' + id)
}
export async function updateSignNowSignature(rentalId, signed, status = null) {
    let obj = {
        Signed: signed,
        Status: status
    };

    return await put(obj, 'rental/signnow/' + rentalId)
}
export async function resendSignNowSignature(rentalId) {
    return await put(null, 'rental/signnow/' + rentalId + '/resend')
}
export async function sendElectronicSignatureReminder(rentalId) {
    return await put(null, 'rental/signnow/' + rentalId + '/reminder')
}
export async function skipPayment(id) {

    return await put(null, 'rental/skip-payment/' + id)
}
export async function closeRentalNow(id) {
    return await put(null, 'rental/close-now/' + id)
}
export async function clientCancellation(id) {
    return await put(null, 'rental/client-cancellation/' + id)
}
export async function getUnpaidAdvanceClosureEmail(id) {
    return await get('rental/unpaid-advance-closure/' + id)
}
export async function closeUnpaidAdvanceRental(id, sendEmail = false) {
    return await put(null, 'rental/unpaid-advance-closure/' + id + '?sendEmail=' + (sendEmail ? 'true' : 'false'))
}

export async function extractBricolibContract(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch('/api/rental/extract-bricolib-contract', {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        body: formData
    });

    if (response.status === 401) {
        return null;
    }

    return await response.json();
}

export async function createRental(params) {
    let bd = null;
    if (!IsNullOrEmpty(params.birthdate)) {
        bd = new Date(params.birthdate);
        bd.setHours(5);
    }
    var toArrayMaterial = [];
    // convert "zazaz,zadfrg,asdas" to array
    if (!IsNullOrEmpty(params.material)) {
        toArrayMaterial = params.material.split(",");
    }



    let dtSplitted = params.dates.split(",");

    let st = new Date(dtSplitted[0]);
    st.setHours(5);

    let en = new Date(dtSplitted[1]);
    en.setHours(5);
    var newStartHour = params.rentalHour.replace("h", "");
    var newEndHour = params.rentalHourEnd.replace("h", "");

    let rental = {
        ClientFirstname: params.firstname,
        ClientLastname: params.lastname,
        ClientBirthdate: bd,
        ClientBirthplace: params.birthplace,
        ClientPhone: normalizePhone(params.phone),
        ClientEmail: params.email,
        ClientType: params.clientType,
        CompanyName: params.companyName,
        Siret: params.siret,
        Material: toArrayMaterial,
        ServiceId: params.serviceId,
        StartDate: st,
        EndDate: en,
        DepositType: params.deposit,
        Hour: newStartHour,
        EndHour: newEndHour,
        ClientAddress: params.address,
        DeliveryAddress: params.deliveryAddress,
        DeliveryFeesCents: normalizeMoneyParam(params.deliveryFees),
        DeliveryDistanceMeters: toNullableInt(params.deliveryDistanceMeters),
        DeliveryDurationSeconds: toNullableInt(params.deliveryDurationSeconds),
        DeliveryOriginWarehouseId: toNullableInt(params.deliveryOriginWarehouseId),
        CustomPriceCents: normalizeMoneyParam(params.customPrice),
        Options: params.options,
        Comment: params.comment,
        PermanentLinkDeposit: params.permanentLinkDeposit,
        SelectedOptions: params.selectedOptions,
        AvailableDeposit: params.availableDeposit,
        Delivery: params.deliveryId,
        AdvancePaymentAmountCentsNeeded: normalizeMoneyParam(params.advancePaymentAmountCentsNeeded),
        AdvancePaymentCollectionMode: params.advancePaymentCollectionMode,
        SignatureRequired: params.signatureRequired === "1" || params.signatureRequired === true,
        RentalContacts: parseRentalContacts(params.rentalContacts)
    };

    return await post(rental, 'rental')
}
export async function updateRentalData(params, id) {
    let bd = null;
    if (!IsNullOrEmpty(params.birthdate)) {
        bd = new Date(params.birthdate);
        bd.setHours(5);
    }

    let dtSplitted = params.dates.split(",");

    let st = new Date(dtSplitted[0]);
    st.setHours(5);

    let en = new Date(dtSplitted[1]);
    en.setHours(5);
    var newHour = params.rentalHour.replace("h", "");
    var newEndHour = params.rentalHourEnd.replace("h", "");


    var toArrayMaterial = [];
    // convert "zazaz,zadfrg,asdas" to array
    if (!IsNullOrEmpty(params.material)) {
        toArrayMaterial = params.material.split(",");
    }



    let rental = {
        ClientFirstname: params.firstname,
        ClientLastname: params.lastname,
        ClientBirthdate: bd,
        ClientBirthplace: params.birthplace,
        ClientPhone: normalizePhone(params.phone),
        ClientEmail: params.email,
        ClientType: params.clientType,
        CompanyName: params.companyName,
        Siret: params.siret,
        Material: toArrayMaterial,
        ServiceId: params.serviceId,
        StartDate: st,
        EndDate: en,
        DepositType: params.deposit,
        Hour: newHour,
        EndHour: newEndHour,
        ClientAddress: params.address,
        DeliveryAddress: params.deliveryAddress,
        DeliveryFeesCents: normalizeMoneyParam(params.deliveryFees),
        DeliveryDistanceMeters: toNullableInt(params.deliveryDistanceMeters),
        DeliveryDurationSeconds: toNullableInt(params.deliveryDurationSeconds),
        DeliveryOriginWarehouseId: toNullableInt(params.deliveryOriginWarehouseId),
        CustomPriceCents: normalizeMoneyParam(params.customPrice),
        Options: params.options,
        Comment: params.comment,
        PermanentLinkDeposit: params.permanentLinkDeposit,
        SelectedOptions: params.selectedOptions,
        AvailableDeposit: params.availableDeposit,
        Delivery: params.deliveryId,
        AdvancePaymentAmountCentsNeeded: normalizeMoneyParam(params.advancePaymentAmountCentsNeeded),
        AdvancePaymentCollectionMode: params.advancePaymentCollectionMode,
        SignatureRequired: params.signatureRequired === "1" || params.signatureRequired === true,
        RentalContacts: parseRentalContacts(params.rentalContacts)
    };
    return await put(rental, 'rental/' + id)
}

// Outil d'estimation des frais de livraison (trajet Google Routes + tarif du loueur).
export async function getDeliveryEstimateOrigins() {
    return await get('rental/delivery-estimate/origins')
}
export async function estimateDeliveryFees(payload) {
    return await post(payload, 'rental/delivery-estimate')
}
export async function autocompleteDeliveryAddress(input) {
    return await get('rental/delivery-estimate/autocomplete?input=' + encodeURIComponent(input || ''))
}
export async function getDeliveryFuelPrice(fuel) {
    return await get('rental/delivery-estimate/fuel-price?fuel=' + encodeURIComponent(fuel || 'gazole'))
}
